import { Column } from '@access-erp/common';
import { CellType, FilterValueTypes } from '@access-erp/ui-components';

import { CellFormatters } from '@/components/common/EnquiriesScreen/utils/CellFormatters';
import { filtersforStringifiedNumbers } from '@/components/common/EnquiriesScreen/utils/filtersForStringigfiedNumbers';
import { filterPurchaseOrdersStatuses } from '@/config/statuses.config';
import { guidFilterOptions } from '@/components/common/EnquiriesScreen/utils/filters.config';

export interface UseTransactionTableColumnsReturn {
  headerColumns: Column<unknown>[];
}

const VISIBLE_REASON_CHARS_LENGTH = 50;

export const getHeaderColumns = (): Column<unknown>[] => [
  {
    name: 'customerName',
    caption: 'Account Name',
    width: 200,
    cellType: CellType.String,
    defaultFilter: 1,
  },
  {
    name: 'customerCode',
    caption: 'Account',
    width: 200,
    cellType: CellType.String,
    defaultFilter: 2,
  },
  {
    name: 'poNumber',
    caption: 'Number',
    width: 200,
    cellType: CellType.String,
    defaultFilter: 3,
  },
  {
    name: 'poDate',
    caption: 'Date',
    width: 200,
    cellType: CellType.Date,
    cellFormatter: CellFormatters.date,
    defaultFilter: 4,
  },
  {
    name: 'poStartDate',
    caption: 'Start Date',
    width: 200,
    cellType: CellType.Date,
    cellFormatter: CellFormatters.date,
    defaultFilter: 5,
  },
  {
    name: 'poEndDate',
    caption: 'End Date',
    width: 200,
    cellType: CellType.Date,
    cellFormatter: CellFormatters.date,
    defaultFilter: 6,
  },
  {
    name: 'poTotalValue',
    caption: 'Total Value',
    width: 200,
    cellType: CellType.String,
    defaultFilter: 7,
    cellFormatter: CellFormatters.decimal,
    filterType: FilterValueTypes.StringFilter,
    groupable: false,
    filterOptions: {
      availableOptions: filtersforStringifiedNumbers,
    },
    cellStyle: { justifyContent: 'end' },
  },
  {
    name: 'poRemainingValue',
    caption: 'Remaining Value',
    width: 200,
    cellType: CellType.String,
    defaultFilter: 8,
    cellFormatter: CellFormatters.decimal,
    filterType: FilterValueTypes.StringFilter,
    groupable: false,
    filterOptions: {
      availableOptions: filtersforStringifiedNumbers,
    },
    cellStyle: { justifyContent: 'end' },
  },
  {
    name: 'poStatus',
    caption: 'Status',
    width: 100,
    cellType: CellType.String,
    filterType: FilterValueTypes.EnumFilter,
    filterData: filterPurchaseOrdersStatuses,
    defaultFilter: 9,
    cellRenderer: ({ value }) =>
      !!value && value !== 'Active' ? <span>{'\u26A0\uFE0F ' + value}</span> : <span>{value}</span>,
  },
  {
    name: 'poNote',
    caption: 'Note',
    width: 200,
    cellType: CellType.String,
    defaultFilter: 10,
    filterable: false,
    suppressAdvancedFilter: true,
    disableRowGroup: true,
    sortable: false,
    cellRenderer: ({ value }) => {
      const reasonForFailureTrimmed =
        value && value.length > VISIBLE_REASON_CHARS_LENGTH
          ? value.slice(0, VISIBLE_REASON_CHARS_LENGTH) + '...'
          : value || '';

      const titlePopUp = value && value.length > VISIBLE_REASON_CHARS_LENGTH ? value : undefined;

      return <div title={titlePopUp}>{reasonForFailureTrimmed}</div>;
    },
  },
  {
    name: 'poCurrency',
    caption: 'Currency',
    width: 120,
    cellType: CellType.String,
    defaultFilter: 11,
  },
  {
    name: 'id',
    caption: 'ID',
    width: 270,
    cellType: CellType.String,
    defaultFilter: 12,
    hidden: true,
    filterType: FilterValueTypes.StringFilter,
    filterOptions: {
      availableOptions: guidFilterOptions,
    }
  },
];
